module.exports = __webpack_public_path__ + "img/ddos.8d0e349.svg";